import { SubFilterObject, UniformFilterObject } from "./types";

type OptionMutator = (
    option: SubFilterObject[string]
) => SubFilterObject[string];

const mapAllOptions = (
    state: UniformFilterObject,
    mutate: OptionMutator
): UniformFilterObject =>
    Object.fromEntries(
        Object.entries(state).map(([filterId, subFilter]) => [
            filterId,
            Object.fromEntries(
                Object.entries(subFilter).map(([optionId, option]) => [
                    optionId,
                    mutate(option)
                ])
            )
        ])
    );

export const commitStagedFilters = (
    state: UniformFilterObject
): UniformFilterObject =>
    mapAllOptions(state, (option) => ({
        ...option,
        committedActive: option.stagedActive
    }));

export const countActiveFilterOptions = (
    filterId: string,
    state: UniformFilterObject
): number =>
    Object.values(state[filterId] ?? {}).reduce(
        (count, option) => (option.committedActive ? count + 1 : count),
        0
    );

export const countAllActiveFilters = (state: UniformFilterObject): number =>
    Object.keys(state).reduce(
        (count, filterId) => count + countActiveFilterOptions(filterId, state),
        0
    );
